import MarkdownRender from 'components/Luxkit/MarkdownRender'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import React, { useCallback } from 'react'

interface Props {
  title?: string
  content: string
}

function NotificationBannerV2Modal({ title, content }: Props) {
  const { resolve } = useModalElementContext()

  const close = useCallback(() => {
    resolve()
  }, [resolve])

  return (
    <ModalBase height="full" tabletHeight="auto">
      {title && <ModalHeader title={title} />}
      <ModalBody>
        <ModalContent>
          <MarkdownRender content={content} />
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'OK',
          onClick: close,
        }}
      />
    </ModalBase>
  )
}

export default NotificationBannerV2Modal
